/**
 * NVISION Chatbot launcher — loads widget when config is present.
 * Can be embedded via GTM without WordPress enqueue.
 */
(function () {
  if (window.NvisionChatLauncherLoaded) return;
  window.NvisionChatLauncherLoaded = true;

  var config = window.NvisionChatConfig || {};
  var themeUri = config.themeUri || '/wp-content/themes/nvision-v2';

  function loadScript(src, onload) {
    var s = document.createElement('script');
    s.src = src;
    s.async = true;
    if (onload) s.onload = onload;
    document.head.appendChild(s);
  }

  function start() {
    if (window.__nvisionChatWidgetInstance) return;
    var version = config.assetsVersion || config.widgetVersion || '';
    var query = version ? '?v=' + encodeURIComponent(version) : '';
    var widgetSrc = themeUri + '/dist/chatbot/widget.js' + query;
    loadScript(widgetSrc);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
